// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".scroll-up[data-v-231b54ab]{-webkit-animation:fade-in-up-data-v-231b54ab .25s ease;animation:fade-in-up-data-v-231b54ab .25s ease}@-webkit-keyframes fade-in-up-data-v-231b54ab{0%{transform:translateY(100%);opacity:0}to{transform:translateY(0);opacity:1}}@keyframes fade-in-up-data-v-231b54ab{0%{transform:translateY(100%);opacity:0}to{transform:translateY(0);opacity:1}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
